import React, { useState, useEffect } from 'react';

import micSvg from '../assets/mic.svg';

type Props = {
    handleVoice: Function,
    setIsrecording: Function,
    isThinking: boolean
}

const Rec = ({ handleVoice, setIsrecording, isThinking }: Props) => {
    const [stream, setStream] = useState<MediaStream>();
    const [mic, setMic] = useState<any>({
        access: false,
        recorder: null
    });
    const [chunks, setChunks] = useState([]);

    useEffect(() => {
        mic.access && mic.recorder.start();
    }, [mic]);

    const getMic = async () => {
        if ('MediaRecorder' in window) {
            try {
                await navigator.mediaDevices.getUserMedia({
                    audio: true
                }).then(micData => {
                    setStream(micData);
                    const mimeTypes = ['audio/wav', 'audio/mpeg', 'audio/webm'];
                    const mime = mimeTypes.filter(MediaRecorder.isTypeSupported)[0];
                    const mimeExt = '.' + mime.split('/')[1];
                    // console.log('______ mime isTypeSupported:', mime, mimeExt);
                    const mediaRecorder = new MediaRecorder(micData, {mimeType: mime});
                    setMic({
                        access: true,
                        recorder: mediaRecorder
                    });
                    const chunks = [] as any[];
                    mediaRecorder.addEventListener('start', () => {
                        setIsrecording(true);
                    });
                    mediaRecorder.addEventListener('dataavailable', event => {
                        if (typeof event.data === 'undefined') return;
                        if (event.data.size === 0) return;
                        chunks.push(event.data);
                    });
                    mediaRecorder.addEventListener('stop', () => {
                        setIsrecording(false);
                        setChunks([]);
                        const audioBlob = new Blob(chunks, { type: mime });
                        const audioUrl = URL.createObjectURL(audioBlob);
                        const formData = new FormData();
                        formData.append('audio_input', audioBlob, 'rec' + mimeExt);
                        handleVoice(formData, audioUrl);
                    });
                });
            } catch (error: any) {
                console.log(error.message);
            }
        } else {
            alert('The MediaRecorder API is not supported in your browser.');
        }
    };
    const stopStream = () => {
        mic?.recorder?.stop();
        stream?.getTracks().forEach((track) => track.stop());
        setMic({
            access: false
        });
    };

    return (
        <>
            <div className="audio-controls">
                {/* <button type="button" className={!mic.access ? 'get-mic' : 'rec-stop'} onClick={!mic.access ? getMic : stopStream} disabled={isThinking} style={{ backgroundImage:`url(${ micSvg})` }}></button> */}
            </div>
        </>
    );
};
export default Rec;